import React from "react";
import { TransactionLocked } from "@common/constants";
import { FilterMultiselectOption } from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import { TriStateBooleanFilter } from "../TriStateBooleanFilter/TriStateBooleanFilter";

const lockedOption: FilterMultiselectOption = {
    value: TransactionLocked.LOCKED,
    label: "Locked",
    searchableLabel: "locked",
};

const unlockedOption: FilterMultiselectOption = {
    value: TransactionLocked.UNLOCKED,
    label: "Unlocked",
    searchableLabel: "unlocked",
};

function isLockedToTransactionLocked(
    isLocked: boolean | undefined,
): TransactionLocked | undefined {
    if (isLocked === undefined) {
        return undefined;
    }
    return isLocked ? TransactionLocked.LOCKED : TransactionLocked.UNLOCKED;
}

export const TransactionLockedFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => (
    <TriStateBooleanFilter
        value={
            filters.transactionLocked === undefined
                ? undefined
                : filters.transactionLocked === TransactionLocked.LOCKED
        }
        onChange={(isLocked) =>
            onChange({
                transactionLocked: isLockedToTransactionLocked(isLocked),
            })
        }
        trueOption={lockedOption}
        falseOption={unlockedOption}
        name="transactionLocked"
    />
);
